export default __webpack_public_path__ + "static/media/ID_9.8d4cd09b.jpg";